module.exports = __webpack_public_path__ + "static/quiz-de5d2c99ae3d365acf160a02f7aa037b.png";